import { useMutation } from '@tanstack/react-query';

export interface UploadFileActiveStorageParams {
  file: File;
  url: string;
  headers: Record<string, string>;
}

const uploadFileActiveStorage = ({ url, headers, file }: UploadFileActiveStorageParams): Promise<any> =>
  fetch(url, {
    method: 'PUT',
    headers,
    body: file,
  });

export const useUploadFileActiveStorage = (mutationOptions?: { retry: number }) =>
  useMutation(uploadFileActiveStorage, mutationOptions);
